import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "tag", "selected", "template", "addButton"]

  connect() {
    this.addButtonTarget.hidden = false
  }

  remove(event) {
    if (event.target.checked) return

    event.target.parentElement.remove()
    this.inputTarget.focus()
  }

  add(event) {
    if (event.isComposing) return

    event.preventDefault()
    event.stopPropagation()
    this.parse(this.inputTarget.value).forEach((name) => this.addTag(name))
    this.inputTarget.value = ""
    this.inputTarget.focus()
  }

  parse(value) {
    // Match the comma and quoted-tag syntax of ActsAsTaggableOn::DefaultParser.
    const names = []
    for (const pattern of [/(^|,)\s*"(.*?)"\s*(?=,\s*|$)/g, /(^|,)\s*'(.*?)'\s*(?=,\s*|$)/g]) {
      value = value.replace(pattern, (_match, _delimiter, name) => {
        names.push(name)
        return ""
      })
    }
    return names.concat(value.split(",")).map((name) => name.trim()).filter(Boolean)
  }

  addTag(name) {
    const existing = this.tagTargets.find((tag) => tag.value.toLocaleLowerCase() === name.toLocaleLowerCase())
    if (existing) {
      existing.checked = true
    } else {
      const fragment = this.templateTarget.content.cloneNode(true)
      const input = fragment.querySelector("input")
      const label = fragment.querySelector("label")
      let index = this.tagTargets.length
      while (this.element.querySelector(`#publication-custom-tag-${index}`)) index += 1
      input.id = `publication-custom-tag-${index}`
      input.value = name
      input.checked = true
      label.htmlFor = input.id
      label.querySelector("[data-tag-label]").textContent = name
      label.title = label.title.replace("%tag%", name)
      this.selectedTarget.append(fragment)
    }
  }
}
